// import useAuth from 'hooks/useAuth';

// import { Doc } from '../preferences/preferenceApi';

// const apiHost = import.meta.env.VITE_API_HOST || 'https://docsapi.arc53.com';
const apiHost = process.env.REACT_APP_API_URL;
const api_key = process.env.REACT_APP_OPENAI_KEY;
const project = 'translate';

export function fetchAnswerSteaming(question, apiKey, from_language, to_language, onEvent) {
    return new Promise((resolve, reject) => {
        const body = {
            question: question,
            api_key: api_key,
            embeddings_key: api_key,
            user: localStorage.getItem('user_token'),
            user_type: localStorage.getItem('user_type'),
            project: project,
            from_language,
            to_language
        };

        fetch(`${apiHost}/stream/translate`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(body)
        })
            .then((response) => {
                if (!response.body) throw Error('No response body');

                const reader = response.body.getReader();
                const decoder = new TextDecoder('utf-8');
                let counterrr = 0;
                const processStream = ({ done, value }) => {
                    if (done) {
                        // console.log(counterrr);
                        return;
                    }

                    counterrr += 1;

                    const chunk = decoder.decode(value);

                    const lines = chunk.split('\n');

                    for (let line of lines) {
                        if (line.trim() == '') {
                            continue;
                        }
                        if (line.startsWith('data:')) {
                            line = line.substring(5);
                        }

                        const messageEvent = new MessageEvent('message', {
                            data: line
                        });

                        onEvent(messageEvent); // handle each message
                    }

                    reader.read().then(processStream).catch(reject);
                };

                reader.read().then(processStream).catch(reject);
            })
            .catch((error) => {
                console.error('Connection failed:', error);
                reject(error);
            });
    });
}

export function fetchGrammarCheckSuggestion(question) {
    const body = {
        question: question,
        api_key: api_key,
        user: localStorage.getItem('user_token'),
        user_type: localStorage.getItem('user_type'),
        project: project
    };

    fetch(`${apiHost}/stream/grammar_check`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(body)
    })
        .then((response) => {
            if (!response.body) throw Error('No response body');
            return response.data;
        })
        .catch((error) => {
            console.error('Connection failed:', error);
            return null;
        });
}
